import { useState } from "react";
import classNames from "classnames";
import {
  FAQ,
  GettingStarted,
  TheProcess,
} from "../../../documentation/DataImportSteps";
import { Button } from "../../elements/Button";
import { Modal } from "../../elements/Modal";
import { DataImportAvailableColumns } from "./DataImportAvailableColumns";
import { DataImportManageSources } from "./DataImportManageSources";
import { DataImportSampleFile } from "./DataImportSampleFile";

const tabs = [
  { id: "getting-started", label: "Getting Started", Content: GettingStarted },
  { id: "manage-sources", label: "Manage Sources", Content: DataImportManageSources },
  { id: "sample-import-file", label: "Sample Import File", Content: DataImportSampleFile },
  { id: "the-process", label: "The Process", Content: TheProcess },
  { id: "available-columns", label: "Available Columns", Content: DataImportAvailableColumns },
  { id: "faq", label: "FAQ", Content: FAQ },
];

/** A link to the import guide, which opens over the page in tabs. */
export function DataImportHelp() {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTabId, setActiveTabId] = useState(tabs[0].id);
  const { Content } = tabs.find((tab) => tab.id === activeTabId) ?? tabs[0];

  return (
    <>
      <Button
        text="Need help importing?"
        variant="link"
        className="p-0"
        onClick={() => setIsOpen(true)}
      />
      {isOpen && (
        <Modal
          title="Data import help"
          onClose={() => setIsOpen(false)}
          className="modal-xl modal-steady-height"
        >
          <div className="modal-body d-flex flex-column min-h-0">
            <div className="underline-tabs d-none d-md-flex mb-3">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  className={classNames("underline-tabs__tab", {
                    "underline-tabs__tab--active": activeTabId === tab.id,
                  })}
                  onClick={() => setActiveTabId(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <select
              className="form-select d-md-none mb-3"
              aria-label="Help topic"
              value={activeTabId}
              onChange={(event) => setActiveTabId(event.target.value)}
            >
              {tabs.map((tab) => (
                <option key={tab.id} value={tab.id}>
                  {tab.label}
                </option>
              ))}
            </select>
            <div className="flex-grow-1 min-h-0 overflow-auto">
              <Content />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}

export default DataImportHelp;
